// 积分类型列表参数
class listReq {
	public pageNo: number;
	public pageSize: number;
	public itineraryId: string;

	constructor() {
		this.pageNo = 1;
		this.pageSize = 1000;
		this.itineraryId = "";
	}
}
// 简历信息
class editResumeReq {
	public id: string;
	public name: string;
	public phone: string;
	public nation: string;
	public birthday: any;
	public sex: string;
	public weight: string;
	public height: string;
	public email: string;
	public university: string;
	public universityId: string;
	public sno: string;
	public major: string;
	public majorId: string;
	public education: string;
	public educationId: string;
	public provinces: string;
	public city: string;
	public area: string;
	public attachmentId: string;
	public graduationDate: any;
	public otherPlan: string;
	public workingExperience: string;
	public skillsCompetition: string;
	public socialPractice: string;
	public honour: string;
	public hobby: string;
	public selfAssessment: string;
	public remark: string;
	public pushCode: string;
	public attachmentName: string;
	public attachmentAddress: string;
	public attachmentSize: string;

	constructor() {
		this.id = '';
		this.name = '';
		this.phone = '';
		this.nation = '';
		this.birthday = '';
		this.sex = '';
		this.weight = '';
		this.height = '';
		this.email = '';
		this.university = '';
		this.universityId = '';
		this.sno = '';
		this.major = '';
		this.majorId = '';
		this.education = '';
		this.educationId = '';
		this.provinces = '';
		this.city = '';
		this.area = '';
		this.attachmentId = '';
		this.graduationDate = '';
		this.otherPlan = '';
		this.workingExperience = '';
		this.skillsCompetition = '';
		this.socialPractice = '';
		this.honour = '';
		this.hobby = '';
		this.selfAssessment = '';
		this.remark = '';
		this.pushCode = '';
		this.attachmentName = '';
		this.attachmentAddress = '';
		this.attachmentSize = '';
	}
}

class addResumeReq {
	public phone: string;
	public openId: string;
	public name: string;
	public university: string;
	public universityId: string;
	public major: string;
	public majorId: string;
	public specificMajor: string;
	public education: string;
	public educationId: string;
	public itineraryId: any;
	public captcha: string;
	public password: string;
	public passwordAgain: string;
	public jobName: string;
	public jobId: string;

	constructor() {
		this.phone = '';
		this.openId = '';
		this.name = '';
		this.university = '';
		this.universityId = '';
		this.major = '';
		this.majorId = '';
		this.specificMajor = '';
		this.education = '';
		this.educationId = '';
		this.captcha = '';
		this.password = '';
		this.passwordAgain = '';
		this.itineraryId = '';
		this.jobName = '';
		this.jobId = '';
	}
} 

class addDeliverReq {
	public itineraryId: any;
	public jobName: string;
	public jobId: string;
	constructor() {
		this.itineraryId = '';
		this.jobName = '';
		this.jobId = '';
	}

}
export {
	listReq,
	editResumeReq,
	addResumeReq,
	addDeliverReq
}